import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useSiteData } from '../../context/DataContext';
import CustomArtCard from '../CustomArtCard/CustomArtCard';
import './Collections.css';

const Collections = () => {
    const { categories } = useSiteData();
    return (
        <div className="collections-page">
            <div className="collections-header">
                <motion.span
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="subtitle"
                >
                    Curated Galleries
                </motion.span>
                <motion.h1
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 }}
                >
                    Our Collections
                </motion.h1>
                <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: '80px' }}
                    transition={{ delay: 0.3, duration: 0.8 }}
                    className="header-line"
                ></motion.div>
            </div>

            <div className="collections-grid">
                {categories.map((category, index) => (
                    <motion.div
                        key={category.id}
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.1 }}
                    >
                        <Link to={`/category/${category.id}`} className="collection-card">
                            <div className="card-image-wrapper">
                                <img src={category.image} alt={category.name} />
                                <div className="card-overlay">
                                    <div className="overlay-content">
                                        <span className="explore-text">Explore Collection</span>
                                        <div className="explore-line"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-info">
                                <h3>{category.name}</h3>
                                <p>{category.description || `Discover our ${category.name} collection`}</p>
                            </div>
                        </Link>
                    </motion.div>
                ))}
            </div>

            <CustomArtCard />
        </div>
    );
};

export default Collections;
